export default __webpack_public_path__ + "static/media/upgrade-1-img.310a3906.png";